import { NetworkMemberType } from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/network_pb";

export function resolveNetworkMemberType(
  memberType: NetworkMemberType | undefined,
): NetworkMemberType | null {
  if (
    memberType === NetworkMemberType.SHARED ||
    memberType === NetworkMemberType.ISOLATED ||
    memberType === NetworkMemberType.EGRESS_ONLY
  ) {
    return memberType;
  }

  return null;
}

export function networkModeLabel(memberType: NetworkMemberType): string {
  switch (memberType) {
    case NetworkMemberType.SHARED:
      return "meshed";
    case NetworkMemberType.ISOLATED:
      return "isolated";
    case NetworkMemberType.EGRESS_ONLY:
      return "egress only";
    default:
      return "pending";
  }
}

export const networkModes = [
  {
    type: NetworkMemberType.ISOLATED,
    label: "Isolated",
    description:
      "Cannot connect to or be reached by other compute on the organization's mesh network.",
  },
  {
    type: NetworkMemberType.EGRESS_ONLY,
    label: "Egress only",
    description:
      "Can connect to other compute on the organization's mesh network, but cannot be reached by other compute on the network.",
  },
  {
    type: NetworkMemberType.SHARED,
    label: "Meshed",
    description:
      "Can connect to and be reached by other compute on the organization's mesh network.",
  },
] as const;
